import { Card, Space, Typography } from "antd";

import { LeaveForm } from "../components/LeaveForm";

const { Title } = Typography;

const CreateLeave = () => {
  return (
    <Space
      direction="vertical"
      style={{ margin: 10, width: "-webkit-fill-available" }}
    >
      <Card>
        <Title level={3} style={{ marginBottom: "1em" }}>
          Apply Leave
        </Title>
        <Title
          level={5}
          style={{ color: "#0C377C", textTransform: "uppercase" }}
        >
          Leave Information
        </Title>

        <LeaveForm mode="create" />
      </Card>
    </Space>
  );
};

export default CreateLeave;
